import React from 'react';
import PropTypes from 'prop-types';

import { Title, Controls, Control } from 'features/App';
import AutoSyncStatus from 'components/AutoSyncStatus';
import FeatureNotSupported from 'components/FeatureNotSupported';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';
import { makePath } from 'helpers/link-generation';
import { classListPropTypes, intlMessage } from 'constants/propTypes';

import classesListMessages from './ClassesList.messages';
import ClassesListRow from './ClassesListRow/ClassesListRow';
import './ClassesList.scss';

const { element } = bem('classes-list');

const ClassesList = ({
  classes,
  classTitleLink,
  featureIsSupported,
  locale,
  messages,
  noLinkedClasses,
  showEnableClassToggle,
  updateIsClassEnabled,
}) => {
  let content = (
    <>
      <div className={element('list')}>
        <div className={element('row-header', 'grid grid--middle')}>
          <div className="grid__item 1/2">
            <Message
              as="div"
              className="pt-regular pb-regular pl-large text--medium"
              message={classesListMessages.name}
            />
          </div>
          <div className="grid__item 1/2 text--right">
            <Message
              as="div"
              className="pt-regular pr-large pb-regular text--medium"
              message={classesListMessages.bookable}
            />
          </div>
        </div>
        {classes.map(venueClass => (
          <ClassesListRow
            key={venueClass.classId}
            updateIsClassEnabled={updateIsClassEnabled}
            showEnableClassToggle={showEnableClassToggle}
            classTitleLink={classTitleLink}
            venueClass={venueClass}
          />
        ))}
      </div>
    </>
  );

  if (!featureIsSupported) {
    content = <FeatureNotSupported />;
  } else if (noLinkedClasses) {
    content = (
      <div className="splash">
        <section className="splash__content">
          <Message as="p" message={messages.emptyList} />
        </section>
      </div>
    );
  }

  return (
    <>
      <Message message={messages.title} as={Title} />
      <Controls>
        <Control type="trough" className="mb-medium">
          <Message
            message={classesListMessages.contractDescription}
            as="div"
            className={element('description')}
            values={{
              a: text => (
                <a href={makePath.approvedWellnessServices(locale)} target="_blank" rel="noreferrer">
                  {text}
                </a>
              ),
            }}
          />
        </Control>
        {featureIsSupported && !noLinkedClasses && (
          <Control type="trough">
            <AutoSyncStatus />
          </Control>
        )}
      </Controls>
      {content}
    </>
  );
};

ClassesList.propTypes = {
  classes: classListPropTypes,
  classTitleLink: PropTypes.func,
  featureIsSupported: PropTypes.bool,
  locale: PropTypes.string,
  messages: PropTypes.shape({
    emptyList: intlMessage,
    title: intlMessage,
    confirmClassesHeader: intlMessage,
    confirmClassesDescription: intlMessage,
    editClassesHeader: intlMessage,
    editClassesDescription: intlMessage,
    next: intlMessage,
  }),
  noLinkedClasses: PropTypes.bool,
  showEnableClassToggle: PropTypes.bool,
  updateIsClassEnabled: PropTypes.func,
};

export default ClassesList;
